/** Gate de producto EDL en erlia-auth. */
export const ACCESS_EDL_PERMISSION = 'access:edl';

/**
 * Scopes JWT legacy → permission code en erlia-auth.
 * El resto de códigos (read:alert, create:alert, all:silent, …) coinciden 1:1.
 */
const SCOPE_TO_DIRECTORY_PERMISSION: Record<string, string> = {
  'create:user': 'manage:users',
};

export const resolveDirectoryPermission = (code: string): string =>
  SCOPE_TO_DIRECTORY_PERMISSION[code] ?? code;
